export const eng = {
  about1:
    'With the advent of science and technology, new devices and tools, books continue to be in high demand. However, finding the right book in Barcelona does not always become an easy task.',
  about2:
    'Although there are many publishing houses and bookstores in Spain, there is an unmet demand for some categories of books in our country.',
  about3:
    'Our goal is to gather the literature of our publishers are published abroad in demand in Spain in one place in our online bookstore. This should greatly facilitate the search acquisition of the necessary literature, which will help save customers  time and money.',
  about4:
    'We are constantly researching the demand: developing the relevant sections and categories of our online bookstore.',
  about5:
    'Our activities are also aimed at promoting the successful sale of books published by publishers and authors, placing them as wide as possible for the general public.',
  a_z: 'A-Z',
  aboutShop: 'About Shop',
  acc: 'Account',
  accessWith: 'Quick access with',
  account: 'my account',
  addComment: 'add comment',
  addToCart: 'add to basket',
  adventure: 'adventures',
  alreadyLoggedIn: 'You have already successfully logged in',
  author: 'author',
  authors: 'authors',
  authorBooks: 'author`s books',
  basket: 'basket',
  book: 'book',
  booklyTeam: 'Bookly team',
  buy: 'buy',
  architecture: 'Architecture',
  art: 'Art',
  adventures: 'Adventures',
  aboutUs: 'about us',
  barcelona: 'Barcelona',
  bestsellers: 'Bestsellers',
  bestseller: 'bestsellers',
  biography: 'Biography',
  bookName: 'book name',
  books: 'books',
  classics: 'Classics',
  classic: 'classics',
  cancel: 'cancel',
  comments: 'comments',
  confirmEmail: 'Confirm your email address',
  confirmEmailPleas:
    'We have sent a letter to your email, please confirm your email.',
  confirmation: 'confirmation',
  confirmed: 'confirmed',
  contacts: 'contacts',
  contactUs: 'contact us',
  copied: 'copied',
  children: 'CHILDREN',
  children_educational: 'children`s educational',
  count: 'Count',
  country: 'country',
  c: 'c',
  c_plus_plus: 'c++',
  c_sharp: 'c#',
  css: 'CSS',
  default: 'default',
  delete: 'delete',
  deleteComment: 'Delete this comment?',
  delivery: 'Delivery',
  deliveryText1:
    'In case of buying a book from an online store, it will be delivered free of charge to the address specified in the purchase form within 24 hours, if it is located within the city of Barcelona. In all other cases, you can further verify the terms and conditions of delivery by contacting our operator.',
  description: 'description',
  detectives: 'Detectives',
  detective: 'detective',
  dictionaries: 'Dictionaries',
  dictionarie: 'dictionaries',
  dramaturgy: 'Dramaturgy',
  economy: 'Economy',
  educational: 'EDUCATIONAL',
  educationalCh: 'Educational',
  email: 'email',
  emailNotCorrect: 'Email not correct',
  emailorPasswordIsIncorrect: 'Email or Password is incorrect',
  emailRequired: 'Email is required',
  emailExist: 'This email is already registered',
  encyclopedias: 'Encyclopedias',
  encyclopedia: 'encyclopedias',
  fables: 'Fables',
  fable: 'fables',
  fantasy: 'Fantasy',
  fieldIsRequiered: 'field is required',
  firstName: 'first name',
  firstNameRequired: 'First name is required',
  folklore: 'Folklore',
  forAuthors: 'for authors',
  forAuthorsText1:
    'By collaborating with the Bookly online store, the authors will have the opportunity to:',
  forAuthorsText2:
    'Bookly online store allows all authors to sell any book under the terms of cooperation with the store. We ensure by all means the maximum high visibility of your offers on the Internet.',
  forAuthorsText3:
    "We create separate pages for all the authors who collaborate with us, where their suggestions are presented. We provide the opportunity to post information about the author on this page, to publish excerpts provided by us from works published or translated in the past and in the near future, reviews, announcements about them, as well as any other information related to the author's work in the field of literature.",
  forAuthorsText4:
    'Our site is a platform that allows authors and publishers to collaborate effectively. Using this feature, you can get detailed information about the printing works you are interested in online, which will save you a lot of time.',
  forAuthorsText5:
    'On the pages of the site you can get acquainted with the reviews and opinions of our visitors about your work If you wish, contact the reader.',
  forAuthorsText6:
    'If you wish, you will have the opportunity to get acquainted with some of the demand-related statistics posted on the website. We get this information as a result of studying the actions of the site visitors, their demand, opinions, complaints / suggestions.',
  forPublishinghouses: 'for publishing houses',
  forPublishersText1:
    'By becoming our partner, you will have the opportunity to:',
  forPublishersText2:
    'Bookly online store allows you to sell books published by you, according to the terms of cooperation with the store. We ensure by all means the maximum high visibility of your offers on the Internet.',
  forPublishersText3:
    'For all of our publishing houses, we provide separate pages that provide information about you, your offers for sale and other information related to the activity, which will greatly facilitate further business communication with the authors or other stakeholders who apply to you through our site.',
  forPublishersText4:
    'Our site is a platform that allows publishers, authors, businesses and other stakeholders to collaborate effectively. Taking advantage of this opportunity, you can receive different types of offers and orders online.',
  forPublishersText5:
    'You will have the opportunity to post announcements on upcoming books, advertisements, reviews and other information, free and on a paid basis.',
  forPublishersText6:
    'A separate page will be provided for all books for sale, where detailed information about them will be posted, which will ensure its maximum visibility on the Internet.',
  forPublishersText7:
    'If you wish, you will have the opportunity to get acquainted with some of the demand-related statistics posted on the website. We get this information as a result of studying the actions of the site visitors, their demand, opinions, complaints / suggestions.',
  forTeens: 'For teens',
  forTeen: 'for teens',
  gameBooks: 'Game books',
  gameBook: 'game gooks',
  genre: 'genre',
  goToHome: 'Go to Main',
  hello: 'hello',
  history: 'History',
  home: 'home',
  html: 'HTML',
  imaginative: 'FICTION',
  image: 'image',
  it_and_programing: 'IT & Programing',
  java: 'java',
  javascript: 'javascript',
  jurisprudence: 'Jurisprudence',
  kotlin: 'kotlin',
  language: 'language',
  languages: 'Languages',
  lastName: 'last name',
  lastNameRequired: 'Last name is required',
  liked: 'Liked',
  likedList: 'Liked List',
  lookLost: "Look like you're lost",
  locationName: 'Barcelona, Catalonia, Spain',
  manuals: 'Manuals',
  manual: 'manuals',
  medicine: 'Medicine',
  militaryScience: 'Military science',
  moreComments: 'More Comments',
  mostViewed: 'most viewed',
  musical: 'Musical',
  myAccount: 'my account',
  myBooks: 'my books',
  myOrders: 'my orders',
  new: 'new',
  noBooks: 'There are no books in this category yet',
  noComments: 'There are no comments yet',
  noOrders: 'There are no orders yet',
  noResultsFound: 'no results found',
  novels: 'Novels',
  novel: 'novels',
  onlyUsersComment: 'Only registered users can comment books',
  onlyUsersLike: 'Only registered users can like comments',
  onlyUsersRate: 'Only registered users can rate books',
  orderPlaced: 'order placed',
  orders: 'Orders',
  ordersHistory: 'Orders History',
  others: 'OTHERS',
  other: 'others',
  other_other: 'more others',
  othersOthers: 'Others',
  ourAuthors: 'our authores',
  ourPublishers: 'our publishers',
  pageNoteAvailable: 'The page you are looking for not available!',
  pagesCount: 'pages count',
  password: 'password',
  passwordMore4: 'Password must be more 4 symbols',
  passwordConfirmMore4: 'Password confirm must be more 4 symbols',
  passwordRequired: 'Password is required',
  passwordConfirm: 'password confirm',
  passwordConfirmRequired: 'Password confirm is required',
  passwordsNotMatch: 'Passwords not matched',
  payment: 'payment',
  personalInformation: 'personal information',
  payWithCard: 'pay with card',
  philosophy: 'Philosophy',
  php: 'PHP',
  psychology: 'Psychology',
  poems: 'Poems',
  poem: 'poems',
  politics: 'Politics',
  politic: 'politics',
  popular: 'Popular',
  preschool: 'Preschool',
  price: 'Price',
  priceLowtoHigh: 'price: from lowest to highest',
  priceHightoLow: 'price: from highest to lowest',
  prose: 'Prose',
  publicism: 'Publicism',
  publisher: 'publisher',
  publishers: 'publishers',
  publisherBooks: 'publisher`s books',
  pyton: 'pyton',
  rate: 'rate',
  region: 'region',
  registerAccount: 'sign up',
  registrate: 'registrate',
  religious: 'Religious',
  return: 'Return',
  returnText1:
    'The buyer has the right to return or exchange any printed product purchased in the online bookstore, if not more than 14 days have passed from the moment of purchase, if its consumer properties, quality have been preserved, the document certifying the purchase.',
  returnText2:
    '-If the purchased book is of improper quality, has a print bug or other damage.',
  returnText3:
    '-If the ordered product does not correspond to the description mentioned on the website.',
  returnText4:
    'The product will not be returned if it has been used or damaged.',
  riddles: 'Riddles',
  riddle: 'riddles',
  quantity: 'quantity',
  rememberPassword: 'remember password',
  save: 'save',
  search: 'Search',
  searchResults: 'search results',
  selectCountry: 'Select Country',
  selectRegion: 'Select Region',
  services: 'services',
  settings: 'settings',
  shippingAddress: 'shipping address',
  sortBy: 'Sort By',
  street: 'street',
  suggestions: 'suggestions',
  signIn: 'Sign In',
  signOut: 'sign out',
  signUp: 'Sign Up',
  scientific: 'Scientific',
  swift: 'swift',
  tales: 'Tales',
  tale: 'tales',
  telephone: 'telephone',
  telephoneNotCorrect: 'Telephone not correct',
  telephoneRequired: 'Telephone is required',
  textbook: 'Textbook',
  totalPrice: 'total price',
  tourism: 'Tourism',
  town: 'town',
  typescript: 'typescript',
  update: 'update',
  upTo10Years: 'Up to 10 years',
  upTo10Year: 'up to 10 years',
  z_a: 'Z-A',
  year: 'year',
  yourBasketIsEmpty: 'Your basket is empty',
}
